import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';

const GlobalNotice = () => {
  const location = useLocation();

  const [topNotice, setTopNotice] = useState(null);
  const [hideNotice, setHideNotice] = useState(false);

  useEffect(() => {
    let mounted = true;

    axios
      .get('/api/platform-home?type=pickup', {
        withCredentials: true,
      })
      .then((res) => {
        if (!mounted) return;

        setTopNotice(res?.data?.top_notice || null);
      })
      .catch((err) => {
        console.error('상단 공지 조회 실패:', err);

        if (mounted) {
          setTopNotice(null);
        }
      });

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const isMobile = () => window.innerWidth <= 767.98;

    const handleScroll = () => {
      if (!isMobile()) {
        setHideNotice(false);
        return;
      }

      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 80) {
        setHideNotice(true);
      } else {
        setHideNotice(false);
      }

      lastScrollY = currentScrollY;
    };

    const handleResize = () => {
      if (!isMobile()) {
        setHideNotice(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const hiddenPaths = [
    '/seller',
    '/platform_admin',
    '/pos',
    '/kiosk',
    '/kitchen',
    '/table',
    '/waiting',
    '/smartfarm/3d',
  ];

  const shouldHideOnPage = hiddenPaths.some((path) =>
    location.pathname.startsWith(path)
  );

  if (shouldHideOnPage) {
    return null;
  }

  return (
    <>
      <style>{`
        .global-notice-wrap {
          position: relative;
          z-index: 1300;
        }

        .community-notice-strip {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;

          height: 28px;

          background: #eeeeee;
          color: #000;

          display: flex;
          align-items: center;
          justify-content: center;

          padding: 0 15px;

          font-size: 12px;
          font-weight: 600;

          z-index: 1300;

          transition: transform 0.25s ease;
        }

        .community-notice-strip a {
          display: block;
          max-width: 100%;

          color: #000;
          text-decoration: none;

          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .community-notice-strip a:hover,
        .community-notice-strip a:focus,
        .community-notice-strip a:active {
          color: #000;
          text-decoration: none;
        }

        @media (max-width: 767.98px) {
          .global-notice-hidden .community-notice-strip {
            transform: translateY(-28px);
          }
        }
      `}</style>

      <div
        className={`global-notice-wrap ${
          hideNotice ? 'global-notice-hidden' : ''
        }`}
      >
        <div className="community-notice-strip">
          {topNotice ? (
            <Link to={`/notice/${topNotice.id}`}>
              {topNotice.title}
            </Link>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default GlobalNotice;